/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkItemSource = {
    Configuration: 'Configuration',
    Execution: 'Execution'
} as const;
export type WorkItemSource = typeof WorkItemSource[keyof typeof WorkItemSource];


export function WorkItemSourceFromJSON(json: any): WorkItemSource {
    return WorkItemSourceFromJSONTyped(json, false);
}

export function WorkItemSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkItemSource {
    return json as WorkItemSource;
}

export function WorkItemSourceToJSON(value?: WorkItemSource | null): any {
    return value as any;
}

/**
 * Check if a given object implements the WorkItemSource interface.
 */
 export function instanceOfWorkItemSource(value: any): value is WorkItemSource {
    return Object.values(WorkItemSource).includes(value)
}

